const leaflets = {
  "sigma": {
    "config": {
      "primary-color": "rgb(6, 68, 139)",
      "secondary-color": "rgb(227, 3, 15)",
      "tertiary-color": "#ffdd00",
      "hover-color": "rgba(220, 35, 17, 0.5)",
      "primary-alpha-color": "rgba(35, 94, 157, 0.7)",
      "clientIcon": require("assets/images/logo_sigma_realco.png"),
      "serverPath": "realco.volantinointerattivo.net/",
      "pdfPath": "/media/pdf/volantino.pdf",
      "shareFlyerTitle": "Sigma Realco | Volantino interattivo",
      "shareFlyerURL": "https://realco.volantinointerattivo.net?v=141",
      "shareProductSentence": "Guarda il Volantino di Sigma Realco!",
      "ogTitleMeta": "Sigma Realco | Volantino interattivo",
      "ogDescriptionMeta": "Dai uno sguardo al volantino interattivo di Sigma Realco. Offerte valide dal 30/09 al 13/10",
      "ogImageMeta": "https://realco.volantinointerattivo.net/media/images/sigma_fb.png",
      "filterBrand": 0,
      "filterUnderprice": 0,
      "brandImage": "",
      "underPriceImage": "",
      "ga_active": false,
      "ga_tracking_id": "UA-152069090-",
      "release_id": "1",
      "send_grocery_list_to_market": false,
      "grocery_list_min_value": 20,
      "client_id": 29,
      "signboard_id": 46,
      "has_pages": true,
      "hide_grocery_list": false,
      "hide_searchbar": false,
      "line_through": false,
      "category_banner": "/media/images/banner.png",
      "category_banner_mobile": "",
      "hide_plus_product": false,
      "hide_plus_product_price": false,
      "type": "leaflet",
      "product_banner": "",
      "href_banner": "",
      "internal_banner_click": false,
      "external_banner_click": false,
      "add_icon_list": true

    },
    "video": {
        "show_only_once": true,
        "mandatory_seconds": 4,
        "videos": [
            {
                page: 1,
                url: "/media/video/video.mp4",
                item_id: "185218"
            }
        ],
    },
    "leaflet": {
      "name": "DEMO Sigma",
      "code": "141",
      "id_campaign": "141",
      "index": {
        "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/Indice_demo_sigma_ebi9FYP.png",
        "links": [
          {
            "page": 2,
            "blueprint": {
              "top": 25.142146410803132,
              "left": 8.3125,
              "width": 84.6875,
              "height": 7.675906183368867
            }
          },
          {
            "page": 6,
            "blueprint": {
              "top": 32.818052594172,
              "left": 8.3125,
              "width": 84.6875,
              "height": 6.2544420753376
            }
          },
          {
            "page": 8,
            "blueprint": {
              "top": 39.07249466950961,
              "left": 8.3125,
              "width": 84.6875,
              "height": 5.810234541577823
            }
          },
          {
            "page": 10,
            "blueprint": {
              "top": 44.882729211087444,
              "left": 8.3125,
              "width": 84.6875,
              "height": 6.378820184790337
            }
          },
          {
            "page": 12,
            "blueprint": {
              "top": 51.26154939587777,
              "left": 8.3125,
              "width": 84.6875,
              "height": 5.934612651030559
            }
          },
          {
            "page": 16,
            "blueprint": {
              "top": 57.196162046908334,
              "left": 8.3125,
              "width": 84.6875,
              "height": 5.3837953091684465
            }
          },
          {
            "page": 21,
            "blueprint": {
              "top": 62.57995735607678,
              "left": 8.3125,
              "width": 84.6875,
              "height": 6.307746979388768
            }
          },
          {
            "page": 22,
            "blueprint": {
              "top": 68.88770433546556,
              "left": 8.3125,
              "width": 84.6875,
              "height": 5.756929637526656
            }
          },
          {
            "page": 24,
            "blueprint": {
              "top": 74.64463397299221,
              "left": 8.3125,
              "width": 84.6875,
              "height": 6.0589907604832955
            }
          },
          {
            "page": -1,
            "type": "url",
            "url": "https://volantinointerattivo.net",
            "target": "_blank",
            "blueprint": {
              "top": 5.223880597014926,
              "left": 65.3125,
              "width": 30.625,
              "height": 8.955223880597014
            }
          }
        ]
      },
      "categories": [
        {
          "category_name": "Self Service",
          "subcategories": [
            "Salumi",
            "Formaggi",
            "Pasta",
            "Yogurt",
            "Latte"
          ]
        },
        {
          "category_name": "Alimentari",
          "subcategories": [
            "Snack Salati",
            "Dispensa",
            "Colazione",
            "Snack Dolci",
            "Rossi"
          ]
        },
        {
          "category_name": "Surgelati",
          "subcategories": [
            "Verdure"
          ]
        },
        {
          "category_name": "Igiene Casa",
          "subcategories": [
            "Extra",
            "Stoviglie",
            "Bucato"
          ]
        },
        {
          "category_name": "Casa e Cucina",
          "subcategories": [
            "Altro"
          ]
        },
        {
          "category_name": "Igiene Persona",
          "subcategories": [
            "Corpo",
            "Intima"
          ]
        },
        {
          "category_name": "Bevande",
          "subcategories": [
            "Vini e Spumanti",
            "Acqua",
            "Birre",
            "Succhi"
          ]
        },
        {
          "category_name": "Macelleria",
          "subcategories": [
            "Suino",
            "Bovino",
            "Altro",
            "Avicoli"
          ]
        },
        {
          "category_name": "Ortofrutta",
          "subcategories": [
            "Frutta",
            "Verdura"
          ]
        }
      ],
      "pages": [
        {
          "number": 1,
          "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/page_1_81o3DEm.jpg",
          "products": []
        },
        {
          "number": 2,
          "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/page_2_i82j9Gf.jpg",
          "products": [
            {
              "item_id": "cstm47961641",
              "field1": "Crudodolce",
              "field2": "Prosciutto crudo stagionato",
              "field3": "",
              "field4": "",
              "description": "Crudodolce Prosciutto crudo stagionato",
              "grammage": null,
              "price": "4.99",
              "price_label": "€ 4,99",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 8.646391926871745,
                "left": 2.415511932255581,
                "width": 47.691301000769826,
                "height": 42.83038781677229
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_mtaozUI.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ],
              "related": ["cstm84980978", "cstm46899077", "cstm02007918"]
            },
            {
              "item_id": "cstm46899077",
              "field1": "Senfter",
              "field2": "Speck Alto Adige IGP",
              "field3": "",
              "field4": "",
              "description": "Senfter Speck Alto Adige IGP",
              "grammage": null,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 7.6456221039310215,
                "left": 49.98344880677445,
                "width": 21.9667051578137,
                "height": 21.89120382908946
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_x2hchZe_HL5SWN4.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "info",
                  "title": "SPECK ALTO ADIGE IGP",
                  "data": {
                    "titolo": "SPECK ALTO ADIGE IGP",
                    "testo": "Sottili fette di Speck Senfter I.G.P. sofficemente disposte in una comoda confezione da 100 grammi così da essere pronte da servire in qualsiasi occasione.\nCon lo Speck affettato la qualità, il sapore e la tradizione di Senfter sono a portata di frigo. Appena aperta la confezione riconoscerai subito tutto il sapore e i profumi caratteristici delle Dolomiti: la miscela degli aromi e delle spezie, l’affumicatura a freddo e la stagionatura all’aria pura rendono lo Speck Senfter un salume unico.\nLe soffici fette di Speck sono ottime per un secondo piatto ma danno il loro meglio anche come antipasto.\n(Fonte: senfter.it)",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/B73D6VoLDu/images/Senfter-affettato100gr-gusto_delicato-pack_e_impiattato.png"
                    ]
                  }
                }
              ],
              "related": ["cstm47961641", "cstm84980978", "cstm02007918"]
            },
            {
              "item_id": "cstm02007918",
              "field1": "Salumeria Beretta",
              "field2": "Prosciutto cotto",
              "field3": "Alta qualità",
              "field4": "",
              "description": "Salumeria Beretta Prosciutto cotto Alta qualità",
              "grammage": null,
              "price": "3.79",
              "price_label": "€ 3,79",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 7.6456221039310215,
                "left": 71.95015396458817,
                "width": 22.261547344110856,
                "height": 21.89120382908946
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/PNG-Fresca-Salumeria-MAXI-Prosciutto-Cotto-brace-2020_mRFIWFU.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_FuNLQM4_vIELxwU.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ],
              "related": ["cstm84980978", "cstm47961641", "cstm46899077"]
            },
            {
              "item_id": "cstm98681058",
              "field1": "Aia",
              "field2": "Wurstel Wudy",
              "field3": "",
              "field4": "",
              "description": "Aia Wurstel Wudy",
              "grammage": null,
              "price": "1.89",
              "price_label": "€ 1,89",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 29.536825933020484,
                "left": 71.95015396458817,
                "width": 22.261547344110856,
                "height": 21.757756909940568
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_SYYEXVe_16GUVIb.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm77436974",
              "field1": "Beretta",
              "field2": "Cubetti di pancetta",
              "field3": "dolce/affumicata",
              "field4": "",
              "description": "Beretta Cubetti di pancetta dolce/affumicata",
              "grammage": null,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "dolce",
                "affumicata"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 29.536825933020484,
                "left": 50.0737105465743,
                "width": 21.87644341801386,
                "height": 21.757756909940568
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/unnamed_wjjiLhI.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/3766500_4YJ1Hhd.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_nUfwzsO_qPiJ8lt.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm33572425",
              "field1": "Tigre",
              "field2": "Fettine",
              "field3": "",
              "field4": "",
              "description": "Tigre Fettine",
              "grammage": null,
              "price": "0.00",
              "price_label": "€ 1,99",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 51.29458284296104,
                "left": 5.607775211701314,
                "width": 22.442070823710548,
                "height": 21.73723924094473
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_SukGYwe_BZdQO10.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm74917390",
              "field1": "Auricchio",
              "field2": "Provolone piccante",
              "field3": "",
              "field4": "",
              "description": "Auricchio Provolone piccante",
              "grammage": null,
              "price": "4.98",
              "price_label": "€ 4,98",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 51.29458284296104,
                "left": 28.04984603541186,
                "width": 22.598537336412626,
                "height": 21.73723924094473
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/auricchio-provolone-piccante-l-originale-200-g_mj8Xp5N.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_a5ZRshf_5y8JpyM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "hat-chef",
                  "title": "Tortini di melanzane",
                  "data": {
                    "ingredients": "Melanzane (circa 2) 1,6 kg, Pomodorini ciliegino 200 g, Provolone 200 g, Prosciutto cotto 150 g, Aglio 1 spicchio, Acqua 50 ml, Timo q.b., Olio extravergine d'oliva q.b., Sale fino q.b., Pepe nero q.b.",
                    "recipe": "Per preparare i tortini di melanzane, lavate le due melanzane e spuntatele; tagliatene una a fette spesse mezzo centimetro per il senso della larghezza e grigliatele su una griglia di ghisa rovente da entrambe i lati. Poi tagliate l'altra melanzana a fette spesse circa 1 cm e ricavate dei dadini. Poi preparate anche gli altri ingredienti: lavate e tagliate i pomodorini a quarti; sbucciate uno spicchio d'aglio e tritate anche i rametti di timo. Poi tagliate anche il provolone a dadini e il prosciutto cotto a strisce. Irrorate una padella ampia con un filo d'olio e fate rosolare lo spicchio di aglio (potete usarlo intero e toglierlo al termine della cottura). Unite poi il timo tritato e le melanzane a dadini, mescolate con un cucchiao di legno e fate rosolare a fuoco dolce alcuni minuti. Quindi unite i pomodorini e aggiungete l'acqua per favorire la cottura. Salate e pepate a piacere e lasciate cuocere per una decina di minuti fino a quando le melanzane non si saranno ammorbidite. Una volta cotte, spegnete il fuoco. Oleate accuratamente le cocottine di ceramica aiutandovi con un pennello da cucina e adagiate sul fondo una fettina di melanzane. Proseguite con uno strato di melanzane a dadini, poi una striscia di prosciutto cotto e dadini di provolone. Continuate a creare gli strati alternando gli ingredienti e terminate ciascun tortino con uno strato di melanzane e dadini di provolone. Poi ponete le cocottine in una teglia e passatele in forno statico a 200° per 20 minuti (180° per 10 minuti se forno ventilato). Una volta pronti, sfornate i tortini di melanzane e una volta intiepiditi, capovolgeteli sui piatti da portata per servirli!\n(Fonte: ricette.gialloZafferano.it)",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/B73D6VoLDu/images/tortino.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "cstm04583441",
              "field1": "Parmareggio",
              "field2": "Parmiggiano Reggiano DOP",
              "field3": "",
              "field4": "",
              "description": "Parmareggio Parmiggiano Reggiano DOP",
              "grammage": null,
              "price": "1.89",
              "price_label": "€ 1,89",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 51.29458284296104,
                "left": 50.64838337182449,
                "width": 21.44919168591224,
                "height": 21.73723924094473
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_vu3Styb_lthdfBw.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/video/SPOT_IL_GRATTUGIATO_PARMAREGGIO.mp4"
                }
              ]
            },
            {
              "item_id": "cstm77841702",
              "field1": "Granarolo",
              "field2": "Stracchino alta qualità",
              "field3": "",
              "field4": "",
              "description": "Granarolo Stracchino alta qualità",
              "grammage": null,
              "price": "2.35",
              "price_label": "€ 2,35",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 51.29458284296104,
                "left": 72.09757505773673,
                "width": 22.03541185527328,
                "height": 21.73723924094473
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_GNzHhLD_rgAydaw.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm33793042",
              "field1": "Nonno Nanni",
              "field2": "Chiccche",
              "field3": "",
              "field4": "",
              "description": "Nonno Nanni Chiccche",
              "grammage": null,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [
                "Zucca",
                "Spinaci",
                "Patate"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 73.03182208390578,
                "left": 72.09757505773673,
                "width": 22.03541185527328,
                "height": 21.603792321795833
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_LByTtRJ_WpeRx47.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "world",
                  "title": "",
                  "data": "https://www.nonnonanni.it/formaggio-nonno-nanni/chicche-speciali/"
                }
              ]
            },
            {
              "item_id": "cstm57199645",
              "field1": "Granarolo",
              "field2": "Yogurt intero alta qualità",
              "field3": "",
              "field4": "",
              "description": "Granarolo Yogurt intero alta qualità",
              "grammage": null,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Yogurt",
              "blueprint": {
                "top": 73.03182208390578,
                "left": 27.70034642032333,
                "width": 44.397228637413406,
                "height": 21.603792321795837
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_AEoZikh_PuadjEX.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm80755792",
              "field1": "Leerdammer",
              "field2": "Special toast",
              "field3": "",
              "field4": "",
              "description": "Leerdammer Special toast",
              "grammage": null,
              "price": "2.16",
              "price_label": "€ 2,16",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Salati",
              "blueprint": {
                "top": 73.03182208390578,
                "left": 5.664934565050049,
                "width": 22.035411855273278,
                "height": 21.603792321795833
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/LEE76038302-Special-Toast-Gusto-Intenso-Saporito-Straight-HR-210_nKtMMBl.png",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_r4qRvSs_3qYFXzG.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": " Valori Nutrizionali \tper 100g (Peso 125g)",
                  "data": {
                    "specifiche": "Valore energetico (Kcal)\t1530 kJ - 368 kcal, Grassi (g)\t30,0 g, di cui acidi grassi saturi (g)\t20,0 g, Carboidrati (g)\t<0,1 g, di cui zuccheri (g)\t<0,1 g, Proteine (g)\t24,5 g, Sale (g)\t1,9 g, Calcio (g)\t850 mg - 106%*",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/B73D6VoLDu/images/LEE76038302-Special-Toast-Gusto-Intenso-Saporito-Straight-HR-210.png"
                    ]
                  }
                }
              ]
            }
          ]
        },
        {
          "number": 3,
          "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/page_3_qK7upVr.jpg",
          "products": [
            {
              "item_id": "cstm14315720",
              "field1": "Motta",
              "field2": "Caffè oro ",
              "field3": "100% arabica",
              "field4": "",
              "description": "Motta Caffè oro  100% arabica",
              "grammage": null,
              "price": "6.59",
              "price_label": "€ 6,59",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 5.696689761354889,
                "left": 5.6363548883756724,
                "width": 44.40877598152425,
                "height": 23.86451116243264
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_DmwWwFu_s3vFriU.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm36692182",
              "field1": "Giglio",
              "field2": "Latte UHT PS",
              "field3": "",
              "field4": "",
              "description": "Giglio Latte UHT PS",
              "grammage": null,
              "price": "1.25",
              "price_label": "€ 1,25",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Latte",
              "blueprint": {
                "top": 5.696689761354889,
                "left": 50.04513086989993,
                "width": 43.95746728252502,
                "height": 45.65050038491148
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_esDlHvZ_M9jCtC8.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ],
              "related": ["cstm38795831", "cstm58212173"]
            },
            {
              "item_id": "cstm67103490",
              "field1": "Buitoni",
              "field2": "Granfetta",
              "field3": "",
              "field4": "",
              "description": "Buitoni Granfetta",
              "grammage": null,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [
                "Classica",
                "Integrale"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Colazione",
              "blueprint": {
                "top": 29.71516551193226,
                "left": 27.750481139337953,
                "width": 22.294649730561964,
                "height": 21.632024634334105
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_GQyKTTq_vRX6XXJ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm35212777",
              "field1": "Gecchele",
              "field2": "Torta ciambella",
              "field3": "",
              "field4": "",
              "description": "Gecchele Torta ciambella",
              "grammage": null,
              "price": "2.49",
              "price_label": "€ 2,49",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [
                "Yogurt",
                "Bicolore"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Dolci",
              "blueprint": {
                "top": 29.71516551193226,
                "left": 5.81687836797536,
                "width": 21.93360277136259,
                "height": 21.632024634334105
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_rabntj3_4OzbX7a.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm31929128",
              "field1": "Oreo",
              "field2": "Biscotti",
              "field3": "",
              "field4": "",
              "description": "Oreo Biscotti",
              "grammage": null,
              "price": "1.29",
              "price_label": "€ 1,29",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [
                "Doppia crema",
                "Vaniglia",
                "Brownie"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Dolci",
              "blueprint": {
                "top": 51.347190146266364,
                "left": 5.81687836797536,
                "width": 21.93360277136259,
                "height": 21.555042340261743
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_9ByOD2c_nUAwVYB.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "Oreo",
                  "data": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/video/Oreo-Spot-Ferragni.mp4"
                }
              ]
            },
            {
              "item_id": "cstm58212173",
              "field1": "Colussi",
              "field2": "Biscotti",
              "field3": "",
              "field4": "",
              "description": "Colussi Biscotti",
              "grammage": null,
              "price": "1.09",
              "price_label": "€ 1,09",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [
                "Oswego",
                "Zuppalatte"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Colazione",
              "blueprint": {
                "top": 51.347190146266364,
                "left": 27.750481139337953,
                "width": 21.84334103156274,
                "height": 21.555042340261743
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_XEBxmpD_C0rNRsQ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ],
              "related": ["cstm38795831", "cstm36692182"]
            },
            {
              "item_id": "cstm38795831",
              "field1": "Colussi",
              "field2": "Il gran turchese",
              "field3": "",
              "field4": "",
              "description": "Colussi Il gran turchese",
              "grammage": null,
              "price": "3.69",
              "price_label": "€ 3,69",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [
                "Classico",
                "Più"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Colazione",
              "blueprint": {
                "top": 51.347190146266364,
                "left": 49.593822170900694,
                "width": 44.4990377213241,
                "height": 21.555042340261743
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_arhXtQc_DbYuNtm.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "Colussi - Granturchese",
                  "data": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/video/Colussi_Alba_di_una_nuova_colazione_Italiana.mp4"
                }
              ],
              "related": ["cstm36692182", "cstm58212173"]
            },
            {
              "item_id": "cstm07340379",
              "field1": "Sigma",
              "field2": "6 uova fresche",
              "field3": "",
              "field4": "",
              "description": "Sigma 6 uova fresche",
              "grammage": null,
              "price": "1.79",
              "price_label": "€ 1,79",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 72.9022324865281,
                "left": 72.15925712086221,
                "width": 21.93360277136259,
                "height": 21.939953810623557
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_R7rfSh2_UCJoGCa.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/video/I_super_toast_di_Simone_Rugiati.mp4"
                }
              ]
            },
            {
              "item_id": "cstm61900236",
              "field1": "Orogel",
              "field2": "Spinaci cubello /",
              "field3": "Foglia più",
              "field4": "",
              "description": "Orogel Spinaci cubello / Foglia più",
              "grammage": null,
              "price": "3.52",
              "price_label": "€ 3,52",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [
                "Spinaci cubello",
                "Foglia più"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Verdure",
              "blueprint": {
                "top": 72.9022324865281,
                "left": 50.22565434949962,
                "width": 21.933602771362587,
                "height": 21.939953810623557
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_jEs6w5e_bJ7A6HT.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm98414401",
              "field1": "Ambrosoli",
              "field2": "Caramelle",
              "field3": "",
              "field4": "",
              "description": "Ambrosoli Caramelle",
              "grammage": null,
              "price": "1.69",
              "price_label": "€ 1,69",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [
                "Miele",
                "Lattemiele",
                "Balsamiche"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Dolci",
              "blueprint": {
                "top": 72.9022324865281,
                "left": 27.840742879137796,
                "width": 22.384911470361818,
                "height": 21.939953810623557
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_NXCVPdF_r5Eh9TA.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm38895637",
              "field1": "Granarolo",
              "field2": "Panna da cucina",
              "field3": "",
              "field4": "",
              "description": "Granarolo Panna da cucina",
              "grammage": null,
              "price": "1.59",
              "price_label": "€ 1,59",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 72.9022324865281,
                "left": 5.6363548883756724,
                "width": 22.204387990762125,
                "height": 21.939953810623557
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_n7qNTor_a5Yipla.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 4,
          "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/page_4_EyMk5Om.jpg",
          "products": [
            {
              "item_id": "cstm74722214",
              "field1": "Voiello",
              "field2": "Pasta di semola",
              "field3": "formati assortiti 500 g",
              "field4": "",
              "description": "Voiello Pasta di semola formati assortiti 500 g",
              "grammage": null,
              "price": "1.29",
              "price_label": "€ 1,29",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 5.413135575832485,
                "left": 5.574672825250192,
                "width": 44.53214010777521,
                "height": 45.83269728559446
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_8ntZ3eG_MyBG7uA.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ],
              "related": ["cstm37232400", "cstm30724881"]
            },
            {
              "item_id": "cstm88229632",
              "field1": "Curtiriso",
              "field2": "Riso carnaroli",
              "field3": "",
              "field4": "",
              "description": "Curtiriso Riso carnaroli",
              "grammage": null,
              "price": "3.98",
              "price_label": "€ 3,98",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 5.413135575832485,
                "left": 50.10681293302541,
                "width": 21.990762124711317,
                "height": 24.123690357187996
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_BZxvR2I_1bhifzc.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm30724881",
              "field1": "Barilla",
              "field2": "Salsa pronta",
              "field3": "classica/datterini/ciliegini 300 g.",
              "field4": "",
              "description": "Barilla Salsa pronta classica/datterini/ciliegini 300 g.",
              "grammage": 300,
              "price": "1.88",
              "price_label": "€ 1,88",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [
                "Classica", "Datterini", "Ciliegini"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Rossi",
              "blueprint": {
                "top": 29.536825933020484,
                "left": 50.10681293302541,
                "width": 21.990762124711317,
                "height": 21.680774615868202
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_nAf3JRZ_ITYWRpw.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ],
              "related": ["cstm74722214", "cstm37232400"]
            },
            {
              "item_id": "cstm54762766",
              "field1": "Domopak",
              "field2": "15 sacchi nettezza antiforo",
              "field3": "c/manico",
              "field4": "profumazioni assortite",
              "description": "Domopak 15 sacchi nettezza antiforo c/manico profumazioni assortite",
              "grammage": null,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Casa",
              "subcategory": "Extra",
              "blueprint": {
                "top": 51.21760054888868,
                "left": 72.09757505773673,
                "width": 21.876443418013853,
                "height": 21.814221535017097
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_p2j8iuY_3EfpWlz.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm37232400",
              "field1": "Ortolina",
              "field2": "Passata",
              "field3": "690 g.",
              "field4": "",
              "description": "Ortolina Passata 690 g.",
              "grammage": null,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Rossi",
              "blueprint": {
                "top": 5.364385594298382,
                "left": 72.09757505773673,
                "width": 21.876443418013853,
                "height": 45.8532149545903
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_4GD5HBK_qplrbDa.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ],
              "related": ["cstm74722214", "cstm30724881"]
            },
            {
              "item_id": "cstm69147000",
              "field1": "Olive nere",
              "field2": "denocciolate 370 g.",
              "field3": "",
              "field4": "",
              "description": "Olive nere denocciolate 370 g.",
              "grammage": 370,
              "price": "1.59",
              "price_label": "€ 1,59",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 51.47677974364404,
                "left": 49.836027713625874,
                "width": 22.261547344110856,
                "height": 21.603792321795837
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_ZvDIGfV_8vOEXJs.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm57921198",
              "field1": "Giovanna Pavarotti",
              "field2": "Aceto balsamico IGP",
              "field3": "500 ml",
              "field4": "",
              "description": "Giovanna Pavarotti Aceto balsamico IGP 500 ml",
              "grammage": null,
              "price": "5.98",
              "price_label": "€ 5,98",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 51.47677974364404,
                "left": 27.959584295612014,
                "width": 21.87644341801386,
                "height": 21.603792321795837
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_StZ5EuN_erXuOm7.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm31375021",
              "field1": "PAI",
              "field2": "Patatine 300 g",
              "field3": "",
              "field4": "",
              "description": "PAI Patatine 300 g",
              "grammage": null,
              "price": "2.39",
              "price_label": "€ 2,39",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Salati",
              "blueprint": {
                "top": 51.47677974364404,
                "left": 5.968822170900697,
                "width": 21.990762124711317,
                "height": 43.15883466205758
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_94ca7iB_YBch1S7.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm84980978",
              "field1": "Mulino bianco",
              "field2": "Granbauletto rustico",
              "field3": "500 g",
              "field4": "",
              "description": "Mulino bianco Granbauletto rustico 500 g",
              "grammage": 500,
              "price": "2.36",
              "price_label": "€ 2,36",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 72.95483978983341,
                "left": 27.959584295612014,
                "width": 22.05696689761355,
                "height": 21.680774615868202
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_DHdHkdr_muSAYtT.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ],
              "related": ["cstm47961641", "cstm46899077", "cstm02007918"]
            },
            {
              "item_id": "cstm33713667",
              "field1": "TUC",
              "field2": "Sfoglie",
              "field3": "sale/erbe 170 g",
              "field4": "",
              "description": "TUC Sfoglie sale/erbe 170 g",
              "grammage": 170,
              "price": "1.98",
              "price_label": "€ 1,98",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Salati",
              "blueprint": {
                "top": 72.95483978983341,
                "left": 50.01655119322556,
                "width": 22.17128560431101,
                "height": 21.680774615868202
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/TUC_1Ivm1tr.png",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_Gf2P4Dk_kg7hAeA.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "info",
                  "title": "TUC",
                  "data": {
                    "titolo": "TUC",
                    "testo": "Ingredienti:  Farina di frumento, Olio extra vergine di oliva, Lievito, Sale 1,7%, Farina di cereali, maltati (orzo, frumento) ed estratto di malto d'orzo, Può contenere uova e latte.",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/B73D6VoLDu/images/TUC.png"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "cstm96103432",
              "field1": "Sigma",
              "field2": "Sacchetti freezer",
              "field3": "grandi/medi/piccoli",
              "field4": "",
              "description": "Sigma Sacchetti freezer grandi/medi/piccoli",
              "grammage": null,
              "price": "1.68",
              "price_label": "€ 1,68",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [
                "Grandi - 15 pz",
                "Medi - 20 pz",
                "Piccoli - 30 pz"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 72.95483978983341,
                "left": 72.18783679753658,
                "width": 22.1472286374134,
                "height": 21.680774615868202
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_Yk6Rry5_NKbcgt4.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 5,
          "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/page_5_BJMHzdE.jpg",
          "products": [
            {
              "item_id": "cstm93802273",
              "field1": "fria",
              "field2": "salviette bimbi utility",
              "field3": "",
              "field4": "",
              "description": "fria salviette bimbi utility",
              "grammage": null,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": true,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Corpo",
              "blueprint": {
                "top": 5.440799223700131,
                "left": 5.794142562135939,
                "width": 22.288342127571777,
                "height": 24.186969246583917
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/fria-salviette-bimbi-utility_ZTjYxEq.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_iR9XJJH_wQW5WZO.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm48414631",
              "field1": "righi",
              "field2": "pignoletto doc",
              "field3": "",
              "field4": "",
              "description": "righi pignoletto doc",
              "grammage": null,
              "price": "3.98",
              "price_label": "€ 3,98",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": true,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 5.7206750102388195,
                "left": 28.10872915349619,
                "width": 21.79610270156668,
                "height": 24.186969246583917
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/Righi-Reno-Pignoletto-secco2_a1vasr4.png",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_74BqaWh_8HhI1w7.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm32924869",
              "field1": "mil mil",
              "field2": "dermasapone",
              "field3": "maxi ricarica/ talco iris",
              "field4": "",
              "description": "mil mil dermasapone maxi ricarica/ talco iris",
              "grammage": null,
              "price": "3.29",
              "price_label": "€ 3,29",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": true,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Corpo",
              "blueprint": {
                "top": 29.79008489713468,
                "left": 5.958225375158657,
                "width": 21.79610270156668,
                "height": 21.528134861252518
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_njWoa8Q_OUmJjI3.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm77769559",
              "field1": "valtidone bonarda doc",
              "field2": "cantina",
              "field3": "",
              "field4": "",
              "description": "valtidone bonarda doc cantina",
              "grammage": null,
              "price": "4.78",
              "price_label": "€ 4,78",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [
                "Secca",
                "Amabile"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": true,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 29.79008489713468,
                "left": 27.944655353536533,
                "width": 21.79610270156668,
                "height": 21.528134861252518
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/valtidone-bonarda-doc-cantina_J9sscrf.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_BSaUZ5d_2jAyECY.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm98753438",
              "field1": "vera",
              "field2": "acqua",
              "field3": "naturale/frizzante",
              "field4": "",
              "description": "vera acqua naturale/frizzante",
              "grammage": null,
              "price": "0.40",
              "price_label": "€ 0,40",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [
                "Naturale",
                "Frizzante"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": true,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Acqua",
              "blueprint": {
                "top": 5.440795380176438,
                "left": 50.423315744856446,
                "width": 43.78253267994456,
                "height": 45.59754666991022
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/vera-frizzante_rSafZqw.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/vera-naturale_WzkWHnr.jpeg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_rZJcA8b_49zL6uC.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm85619900",
              "field1": "nelsen",
              "field2": "detersivo piatti",
              "field3": "limone / carboni attivi / karité",
              "field4": "",
              "description": "nelsen detersivo piatti limone / carboni attivi / karité",
              "grammage": null,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [
                "Limone",
                "Carboni attivi",
                "Karité"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": true,
              "underpriced_product": false,
              "category": "Igiene Casa",
              "subcategory": "Stoviglie",
              "blueprint": {
                "top": 51.46374892350525,
                "left": 5.794142562135939,
                "width": 22.28833311450872,
                "height": 42.93871997162622
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/nelsen-detersivo-piatti_zI8y8gO.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_1JEihhK_DzmEcU5.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm19068903",
              "field1": "palmolive",
              "field2": "docciaschiuma",
              "field3": "luminous / fabulous / loved",
              "field4": "",
              "description": "palmolive docciaschiuma luminous / fabulous / loved",
              "grammage": null,
              "price": "2.09",
              "price_label": "€ 2,09",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [
                "Luminous",
                "Fabulous",
                "Loved"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": true,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Corpo",
              "blueprint": {
                "top": 51.323813912878684,
                "left": 28.272802953455855,
                "width": 21.467946088584306,
                "height": 21.808018334838586
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/palmolive-docciaschiuma_7Y7oXtC.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_pqsN091_p4wW4gZ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm95690372",
              "field1": "finish ",
              "field2": "detersivo lavastoviglie",
              "field3": "",
              "field4": "",
              "description": "finish  detersivo lavastoviglie",
              "grammage": null,
              "price": "6.28",
              "price_label": "€ 6,28",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": true,
              "underpriced_product": false,
              "category": "Igiene Casa",
              "subcategory": "Stoviglie",
              "blueprint": {
                "top": 73.01427096626739,
                "left": 27.944646340473476,
                "width": 21.79610270156669,
                "height": 21.808018334838586
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/finish-detersivo-lavastoviglie_ipWSrxb.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_aRucR1j_8pwiwFF.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm25257181",
              "field1": "puliorecchie",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "puliorecchie",
              "grammage": null,
              "price": "1.66",
              "price_label": "€ 1,66",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": true,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Corpo",
              "blueprint": {
                "top": 51.3238139128787,
                "left": 49.931076318851346,
                "width": 21.79610270156669,
                "height": 21.388205615911478
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_T6nRa57_ECA31Jb.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm35649172",
              "field1": "tenderly",
              "field2": "carta igienica kilometrica",
              "field3": "",
              "field4": "",
              "description": "tenderly carta igienica kilometrica",
              "grammage": null,
              "price": "3.95",
              "price_label": "€ 3,95",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": true,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Intima",
              "blueprint": {
                "top": 73.15420597689396,
                "left": 50.095150118811006,
                "width": 21.79610270156669,
                "height": 21.388205615911478
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/carta-igienica-tenderly-kilometrica-4-rotoli_OGhkxIL.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_4xp0giz_zOiScPA.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm68861645",
              "field1": "omino bianco",
              "field2": "detersivo liquido",
              "field3": "Muschio bianco / Color / Igienizzante",
              "field4": "",
              "description": "omino bianco detersivo liquido Muschio bianco / Color / Igienizzante",
              "grammage": null,
              "price": "5.99",
              "price_label": "€ 5,99",
              "equivalence": 2,
              "quantity_step": 2,
              "grocery_label": "pz.",
              "varieties": [
                "Muschio bianco",
                "Color",
                "Igienizzante"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": true,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": true,
              "underpriced_product": false,
              "category": "Igiene Casa",
              "subcategory": "Bucato",
              "blueprint": {
                "top": 51.88356164243237,
                "left": 72.24565389714854,
                "width": 21.79610270156669,
                "height": 42.93871997162622
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/Omino-Bianco_ENT319R.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/OB-colore-1500_PmfsTBu.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_zuWkz83_pvuZkEF.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "info",
                  "title": "Omino Bianco",
                  "data": {
                    "titolo": "Omino Bianco",
                    "testo": "Omino Bianco detersivo lavatrice pulisce in profondità, rispetta i tessuti e lascia sui tuoi capi un fresco profumo che dura a lungo.\n\nGrazie alla sua formula dermatologicamente testata, è adatto per il bucato di tutta la famiglia perché garantisce il massimo rispetto della pelle, aiutando a prevenire il rischio di irritazioni.",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/B73D6VoLDu/images/Omino-Bianco.jpg"
                    ]
                  }
                }
              ]
            }
          ]
        },
        {
          "number": 6,
          "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/page_6_1ae5hHu.jpg",
          "products": [
            {
              "item_id": "cstm71196270",
              "field1": "weizen wieninger",
              "field2": "Birra ",
              "field3": "",
              "field4": "",
              "description": "weizen wieninger Birra ",
              "grammage": null,
              "price": "0.95",
              "price_label": "€ 0,95",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Birre",
              "blueprint": {
                "top": 32.159612160785976,
                "left": 2.4611700908363017,
                "width": 24.360117021075403,
                "height": 62.692426013706324
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/weizen-wieninger-Birra_C7fHZ98.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_VAzBBJB_QVJOSGQ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "info",
                  "title": "WIENINGER",
                  "data": {
                    "titolo": "WIENINGER",
                    "testo": "Uno dei classici della tradizione brassicola tedesca, e bavarese in particolare, reinterpretata dai mastri birrai di Wieninger Bier. Questa classica Weissbier versata nel bicchere esprime tutte le caratteristiche dello stile. Il colore dorato torbido, la schiuma pannosa e imponente. Il naso ricco di note fruttate (mela, banana, limone) e speziate (chiodi di garofono). E il classico gusto dolce e fruttato stemperato dalla lieve acidità e da una carbonazione esuberante.",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/B73D6VoLDu/images/weizen-wieninger-Birra.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "cstm34735454",
              "field1": "dab",
              "field2": "birra cruda",
              "field3": "",
              "field4": "",
              "description": "dab birra cruda",
              "grammage": null,
              "price": "1.45",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Birre",
              "blueprint": {
                "top": 32.29954717141254,
                "left": 27.23692677303286,
                "width": 23.04749958220895,
                "height": 31.206279917988436
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/dab-birra-cruda_AAGcCra.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_2r2jwwf_KrwCedR.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm79197915",
              "field1": "weiss erdinger",
              "field2": "birra",
              "field3": "",
              "field4": "",
              "description": "weiss erdinger birra",
              "grammage": null,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Birre",
              "blueprint": {
                "top": 63.64575441298017,
                "left": 27.07284396001014,
                "width": 23.04749958220895,
                "height": 31.206279917988436
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/weiss-erdinger-birra_Pl98a3b.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_B0pWIay_beLRqzL.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm32877378",
              "field1": "clausthaler",
              "field2": "birra analcolica",
              "field3": "",
              "field4": "",
              "description": "clausthaler birra analcolica",
              "grammage": null,
              "price": "1.45",
              "price_label": "€ 1,45",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Birre",
              "blueprint": {
                "top": 32.439482182039114,
                "left": 50.207817577294804,
                "width": 23.04749958220895,
                "height": 31.206279917988436
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/Clausthaler-Lager-Analcolica-33cl_wUc2Gug.webp",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_PLRNG4I_uurT90h.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm70394431",
              "field1": "augustiner helles",
              "field2": "birra",
              "field3": "",
              "field4": "",
              "description": "augustiner helles birra",
              "grammage": null,
              "price": "1.75",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Birre",
              "blueprint": {
                "top": 63.50581555882991,
                "left": 50.04373476427209,
                "width": 23.04749958220895,
                "height": 31.206279917988436
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/augustiner-helles-birra_SR8c9VY.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_X0sBOHg_YaB9Eab.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm74225923",
              "field1": "beck's",
              "field2": "birra",
              "field3": "",
              "field4": "",
              "description": "beck's birra",
              "grammage": null,
              "price": "1.98",
              "price_label": "€ 1,98",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Birre",
              "blueprint": {
                "top": 32.15960447373859,
                "left": 73.50685598147606,
                "width": 26.493144018523918,
                "height": 31.206279917988436
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/birra-becks-in-bottiglia-di-vetro-da-033-l-conf-da-24-pz_szKiCqP.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_p56nbJ8_VNQyaXq.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm31257388",
              "field1": "paulaner",
              "field2": "birra",
              "field3": "",
              "field4": "",
              "description": "paulaner birra",
              "grammage": null,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Birre",
              "blueprint": {
                "top": 63.64575056945648,
                "left": 73.50685598147608,
                "width": 26.493144018523918,
                "height": 31.206279917988436
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/lat-paulaner_grande_yuwxqMa.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_oxrHBfj_IAoweFq.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 7,
          "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/page_7_rKz4g88.jpg",
          "products": [
            {
              "item_id": "cstm04426396",
              "field1": "d'amico",
              "field2": "crauti al naturale",
              "field3": "",
              "field4": "",
              "description": "d'amico crauti al naturale",
              "grammage": null,
              "price": "1.29",
              "price_label": "€ 1,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 36.63763243245239,
                "left": 0.0,
                "width": 26.916301698468494,
                "height": 26.588305418076985
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/DAMICO-CRAUTI-AL-NATURALE_Hcq1xt9.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_ksAkbl0_58hpBot.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm93052007",
              "field1": "iposea",
              "field2": "cetrioli in agrodolce",
              "field3": "",
              "field4": "",
              "description": "iposea cetrioli in agrodolce",
              "grammage": null,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 34.818435015546285,
                "left": 27.07284396001014,
                "width": 22.814357555783367,
                "height": 28.687380543283613
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/IPOSEA-CETRIOLI-IN-AGRODOLCE_Nx3Niam.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_Il4btbW_wVomJzk.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm40535605",
              "field1": "kraft",
              "field2": "maionese leggera squeeze",
              "field3": "",
              "field4": "",
              "description": "kraft maionese leggera squeeze",
              "grammage": null,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 23.623361275238114,
                "left": 50.535965177214116,
                "width": 22.814357555783367,
                "height": 25.88861499084934
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/kraft-maionese-leggera-squeeze_IPMHCbh.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_8ETOkIr_YX5t745.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm04076498",
              "field1": "kraft",
              "field2": "mayonese",
              "field3": "",
              "field4": "",
              "description": "kraft mayonese",
              "grammage": null,
              "price": "1.74",
              "price_label": "€ 1,74",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 23.483422421087845,
                "left": 77.60880913722426,
                "width": 17.892017374110758,
                "height": 25.88861499084934
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/kraft-mayonese_bR6Xhji.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_bi69V7t_9gstiph.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm31587493",
              "field1": "kraft",
              "field2": "maionese",
              "field3": "",
              "field4": "",
              "description": "kraft maionese",
              "grammage": null,
              "price": "0.89",
              "price_label": "€ 0,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 51.19123098531959,
                "left": 50.70004799023685,
                "width": 20.845417877889098,
                "height": 11.8947718545832
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/kraft-maionese-185_vLj6gFy",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_qJnV9dF_qlY6meS.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm93037805",
              "field1": "kraft",
              "field2": "maionese",
              "field3": "",
              "field4": "",
              "description": "kraft maionese",
              "grammage": null,
              "price": "0.75",
              "price_label": "€ 0,75",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 50.91136096406644,
                "left": 74.49132582042321,
                "width": 20.845417877889098,
                "height": 11.8947718545832
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/kraft-maionese-150_3XHtY8I.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_xqLH6TE_8W3F9cj.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm73735900",
              "field1": "brezel",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "brezel",
              "grammage": null,
              "price": "0.45",
              "price_label": "€ 0,45",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Salati",
              "blueprint": {
                "top": 63.50582324587728,
                "left": 0.0,
                "width": 26.259988472503736,
                "height": 30.786459512013934
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/brezel_YxKckgX.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_CDooud2_UQuJV4O.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm50565015",
              "field1": "nazionale arrosto gardani",
              "field2": "braciola di suino al forno / costine / stinco nazionale",
              "field3": "",
              "field4": "",
              "description": "nazionale arrosto gardani braciola di suino al forno / costine / stinco nazionale",
              "grammage": null,
              "price": "14.90",
              "price_label": "€ 14,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [
                "Braciola di suino al forno",
                "Costine",
                "Stinco"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Suino",
              "blueprint": {
                "top": 63.50582324587728,
                "left": 26.908765653518948,
                "width": 23.306587968725395,
                "height": 30.786459512013934
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_EbUaJAA_e0JoOoI.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm94075188",
              "field1": "wurstel ",
              "field2": "grilll party",
              "field3": "",
              "field4": "",
              "description": "wurstel  grilll party",
              "grammage": null,
              "price": "6.98",
              "price_label": "€ 6,98",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 63.64575825650387,
                "left": 50.20781307076327,
                "width": 47.331007825337345,
                "height": 30.786459512013934
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/grill-party-2-crop-big_GcwHFjT.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_ZlGMtK2_wBWTlc3.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 8,
          "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/page_8_4f5U4a1.jpg",
          "products": [
            {
              "item_id": "cstm94388771",
              "field1": "uva bianca",
              "field2": "regina",
              "field3": "",
              "field4": "",
              "description": "uva bianca regina",
              "grammage": null,
              "price": "1.75",
              "price_label": "€ 1,75 al Kg",
              "equivalence": 10,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Frutta",
              "blueprint": {
                "top": 8.799324036259168,
                "left": 3.937870342725471,
                "width": 61.66701851563731,
                "height": 20.96838713169884
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_FXd3JhI_UB1cA98.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm17701384",
              "field1": "Pere williams",
              "field2": "verdi",
              "field3": "",
              "field4": "",
              "description": "Pere williams verdi",
              "grammage": null,
              "price": "1.65",
              "price_label": "€ 1,65 al Kg",
              "equivalence": 10,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Frutta",
              "blueprint": {
                "top": 9.079201744559702,
                "left": 65.95928092207056,
                "width": 30.32815661298238,
                "height": 20.688509423398305
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_XbMV6hT_WD6Czli.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm58905858",
              "field1": "fagiolini",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "fagiolini",
              "grammage": null,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 30.20990338134733,
                "left": 4.101944142685129,
                "width": 30.32815661298238,
                "height": 20.548574412771735
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_5XrPelK_bmsr1Ro.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm64929530",
              "field1": "spinaci",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "spinaci",
              "grammage": null,
              "price": "1.35",
              "price_label": "€ 1,35",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 29.93002951657049,
                "left": 34.45633620639292,
                "width": 31.148543638906794,
                "height": 20.548574412771735
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_J1LWfCH_RdZzMEN.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm73657814",
              "field1": "go-go squeeze",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "go-go squeeze",
              "grammage": null,
              "price": "0.69",
              "price_label": "€ 0,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Succhi",
              "blueprint": {
                "top": 30.06996837072076,
                "left": 65.95928993513361,
                "width": 30.16407379995966,
                "height": 20.548574412771732
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_yAOaVBS_t12vuNg.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm49195748",
              "field1": "patate bologna",
              "field2": "dop",
              "field3": "",
              "field4": "",
              "description": "patate bologna dop",
              "grammage": null,
              "price": "1.47",
              "price_label": "€ 1,47",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 54.97901138251822,
                "left": 3.9378793557885237,
                "width": 30.16407379995966,
                "height": 20.548574412771732
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_tw5g2p7_PBMijzN.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm56551910",
              "field1": "bietole ambruosi e viscardi",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "bietole ambruosi e viscardi",
              "grammage": null,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 54.97901138251822,
                "left": 34.292271419496316,
                "width": 31.312617438866454,
                "height": 20.548574412771732
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_ejyaq6b_JT9uAdn.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm22334674",
              "field1": "funghi champignon",
              "field2": "bianchi",
              "field3": "",
              "field4": "",
              "description": "funghi champignon bianchi",
              "grammage": null,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 54.83907637189166,
                "left": 65.79521613517396,
                "width": 30.32815661298238,
                "height": 20.548574412771732
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_3bnXKuE_9buHBt7.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm57612169",
              "field1": "mele gala",
              "field2": "bio",
              "field3": "",
              "field4": "",
              "description": "mele gala bio",
              "grammage": null,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Frutta",
              "blueprint": {
                "top": 75.8298429980527,
                "left": 4.101962168811243,
                "width": 61.33886190265493,
                "height": 20.548574412771732
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_0ymQ2Gu_NAhwal7.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm73923790",
              "field1": "zucca delica / gialle lunghe",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "zucca delica / gialle lunghe",
              "grammage": null,
              "price": "0.49",
              "price_label": "€ 0,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 75.68990798742612,
                "left": 65.79521613517396,
                "width": 30.32815661298238,
                "height": 20.548574412771732
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_yu3p9Tl_IUAp1aN.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 9,
          "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/page_9_g1FUgoF.jpg",
          "products": [
            {
              "item_id": "cstm54990574",
              "field1": "Bervini beef",
              "field2": "Hamburger di bovino adulto",
              "field3": "Argentina/Canada/Nuova Zelanda/Eurangus",
              "field4": "200 g",
              "description": "Bervini beef Hamburger di bovino adulto Argentina/Canada/Nuova Zelanda/Eurangus 200 g",
              "grammage": null,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Argentina",
                "Canada",
                "Nuova Zelanda",
                "Eurangus"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Bovino",
              "blueprint": {
                "top": 8.92994611239415,
                "left": 4.192167051578137,
                "width": 91.52540415704388,
                "height": 19.938414164742113
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/1_Wc7Rm02.png",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/2_PYAd4HK.png",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/3_NbN4IPW.png",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/4_oj1322E.png",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_fnQd7Dr_R0IJHjO.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "world",
                  "title": "",
                  "data": "http://www.bervini.com/index.php/it/beef/hamburger"
                }
              ]
            },
            {
              "item_id": "cstm86933023",
              "field1": "Luganega",
              "field2": "di suino paesana",
              "field3": "",
              "field4": "",
              "description": "Luganega di suino paesana",
              "grammage": null,
              "price": "5.90",
              "price_label": "€ 5,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Suino",
              "blueprint": {
                "top": 66.97459584295612,
                "left": 4.0116435719784445,
                "width": 46.123749037721325,
                "height": 30.023094688221715
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_MbVPrJE_t943x3L.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm60701714",
              "field1": "Braciole/Costine",
              "field2": "si suino",
              "field3": "",
              "field4": "",
              "description": "Braciole/Costine si suino",
              "grammage": null,
              "price": "4.90",
              "price_label": "€ 4,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Suino",
              "blueprint": {
                "top": 66.97459584295612,
                "left": 50.13539260969977,
                "width": 45.76270207852194,
                "height": 30.023094688221715
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_ocurIXd_jcxV4Oz.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm96926720",
              "field1": "Agnello",
              "field2": "Intero o metà",
              "field3": "",
              "field4": "",
              "description": "Agnello Intero o metà",
              "grammage": null,
              "price": "9.90",
              "price_label": "€ 9,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Altro",
              "blueprint": {
                "top": 33.02540415704388,
                "left": 50.045130869899936,
                "width": 45.76270207852194,
                "height": 14.780600461893766
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_DDrqTOW_8tiivS3.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "hat-chef",
                  "title": "Agnello al forno",
                  "data": {
                    "ingredients": " 1 kg di agnello,  1 kg di patate,  rosmarino,  pepe in grani,  salvia,  vino bianco,  olio di oliva extravergine,  sale",
                    "recipe": "Per prima cosa, mettete a marinare l'agnello mettendolo in una ciotola con rosmarino, salvia, pepe in grani  e vino bianco.\nLasciate la carne nella marinatura per una mezz'ora. Nel frattempo, pelate le patate, tagliatele a tocchetti e man mano mettetele in ammollo nell'acqua per rimuovere l'amido.\nSuccessivamente scolatele e tamponatele per asciugarle. Trascorso il tempo della marinatura trasferite la carne d'agnello in una teglia oliata e salate la carne. Aggiungete quindi le patate facendo ion modo che non vengano sovrapposte alla carne e coprite con un filo d'olio.\nCuocete in forno a 180 °C per 40 minuti, girando a metà cottura e a grill per altri 5 minuti.\nIl vostro agnello al fono è pronto per essere portato in tavola.\n(Fonte: misya.info)",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/B73D6VoLDu/images/agnello-al-forno.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "cstm07008686",
              "field1": "Amadori",
              "field2": "Rollè Bis",
              "field3": "di pollo e tacchino",
              "field4": "",
              "description": "Amadori Rollè Bis di pollo e tacchino",
              "grammage": null,
              "price": "6.99",
              "price_label": "€ 6,99 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Avicoli",
              "blueprint": {
                "top": 47.806004618937656,
                "left": 50.04513086989993,
                "width": 45.76270207852194,
                "height": 14.93456505003849
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_5vGMR9N_nIpsCiI.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm27888222",
              "field1": "Agnello",
              "field2": "Spalla",
              "field3": "",
              "field4": "",
              "description": "Agnello Spalla",
              "grammage": null,
              "price": "10.40",
              "price_label": "€ 10,40 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Altro",
              "blueprint": {
                "top": 32.871439568899156,
                "left": 39.123460354118556,
                "width": 11.011932255581216,
                "height": 14.93456505003849
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/Schermata_del_2020-10-01_11-20-47_K0IGCqK.png",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_QnsTUzJ_TwEpj52.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm34366837",
              "field1": "Agnello",
              "field2": "Cosciotto",
              "field3": "",
              "field4": "",
              "description": "Agnello Cosciotto",
              "grammage": null,
              "price": "10.90",
              "price_label": "€ 10,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Altro",
              "blueprint": {
                "top": 47.806004618937656,
                "left": 39.123460354118556,
                "width": 11.011932255581216,
                "height": 14.318706697459586
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/Schermata_del_2020-10-01_11-20-47_uTzjnEy_YrIPuiz.png",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_p8AyUcS_sdeLkOA.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "cstm58958132",
              "field1": "Agnello",
              "field2": "Bracioline",
              "field3": "",
              "field4": "",
              "description": "Agnello Bracioline",
              "grammage": null,
              "price": "14.90",
              "price_label": "€ 14,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Altro",
              "blueprint": {
                "top": 55.273287143956885,
                "left": 3.8311200923787525,
                "width": 35.292340261739795,
                "height": 7.390300230946883
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/Schermata_del_2020-10-01_11-20-47_VFNovtV_oifrq2o.png",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/products/cropped_image_8UyJx4R_SDCQFIn.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 10,
          "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/page_10_lPsrFpW.jpg",
          "products": []
        },
        {
          "number": 11,
          "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/page_11_AOxVx4t.jpg",
          "products": []
        },
        {
          "number": 12,
          "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/page_12_oHeNTBk.jpg",
          "products": []
        },
        {
          "number": 13,
          "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/page_13_dwt4PsK.jpg",
          "products": []
        },
        {
          "number": 14,
          "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/page_14_cNwq1Q9.jpg",
          "products": []
        },
        {
          "number": 15,
          "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/page_15_2Nl7bp4.jpg",
          "products": []
        },
        {
          "number": 16,
          "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/page_16_jyESoqm.jpg",
          "products": []
        },
        {
          "number": 17,
          "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/page_17_2KPO5Ox.jpg",
          "products": []
        },
        {
          "number": 18,
          "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/page_18_FNVgGnF.jpg",
          "products": []
        },
        {
          "number": 19,
          "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/page_19_qgGgdhO.jpg",
          "products": []
        },
        {
          "number": 20,
          "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/page_20_CHP9T26.jpg",
          "products": []
        },
        {
          "number": 21,
          "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/page_21_YeerNBd.jpg",
          "products": []
        },
        {
          "number": 22,
          "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/page_22_WTuHelz.jpg",
          "products": []
        },
        {
          "number": 23,
          "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/page_23_ENFUmYP.jpg",
          "products": []
        },
        {
          "number": 24,
          "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/page_24_jmCo2bA.jpg",
          "products": []
        },
        {
          "number": 25,
          "image_file": "https://interattivo.s3.amazonaws.com/B73D6VoLDu/pages/fine-sigma_V3blE1U.png",
          "products": []
        }
      ]
    }
  }

}

const lefletSwitch = () => {
  return leaflets.sigma;
}

export const serverResponse = lefletSwitch(); 